<template>

  <el-row :gutter="20" style="margin-top: 10">
    <el-col :span="7" v-if="user.role_id !==4">
        <router-link :to="{ name: 'app.lessons.index', params: {}}"><el-button type="primary">Minhas Aulas</el-button></router-link>
    </el-col>
    <el-col :span="8" v-if="user.role_id ===4">
        <router-link :to="{ name: 'app.lessons.showdemo', params: {}}"><el-button type="primary">Minha Aula</el-button></router-link>
    </el-col>
    <el-col :span="8">
        <router-link :to="{ name: 'administration.postures.showcards', params: {}}"><el-button type="success">Guia de Posturas</el-button></router-link>
    </el-col>
    <el-col :span="8" v-if="user.role_id !==4">
        <router-link :to="{ name: 'app.golds.show', params: {}}"><el-button type="danger">Modelos de Aula</el-button></router-link>
    </el-col>
  </el-row>

</template>

<script>

import { library } from '@fortawesome/fontawesome-svg-core';
import { faEye, faPencilAlt, faListUl } from '@fortawesome/free-solid-svg-icons';
import Typeahead from '../../../components/enso/bulma/Typeahead.vue';
import { Row, Col, Button } from 'element-ui';
import { mapState, mapMutations } from 'vuex';

library.add(faEye, faPencilAlt, faListUl);

export default {
    name: 'Search',

    components: { Typeahead, 'el-row': Row, 'el-col': Col, 'el-button': Button },
    computed: {
      ...mapState(['user']),
    },
    data: () => ({
        query: '',
    }),

    methods: {
        route(search, { routes }) {
            return routes.find(route =>
                route.indexOf(search) >= 0);
        },
        redirect(item, to = null) {
            if (!to && !item.routes.length) {
                return;
            }

            this.$router.push({
                name: to || item.routes[0].name,
                params: { id: item.id },
            });

            this.$nextTick(() => (this.query = ''));
        },
    },
};
</script>

<style lang="scss" scoped>
    .navbar-item.search {
        .route-controls {
            position: absolute;
            right: 1em;

            .route-control {
                z-index: 4;
                opacity: 0.8;
                cursor: pointer;
                margin-right: 0.2em;

                &:hover {
                    opacity: 1;
                }
            }
        }

        position: absolute;

        @media screen and (min-width: 1024px) {
            width: 34em;
            left: calc(50% - 17em);
        }

        @media screen and (min-width: 768px) and (max-width: 1023px) {
            width: 26em;
            left: calc(50% - 13em);
        }

        @media screen and (max-width: 767px) {
            width: 22em;
            left: calc(50% - 11em);
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/core/structure/navbar/Search.vue